import React from 'react';
import { CopyableText, SummarySectionV2, isAccess, isResourceAccess } from '@css-xp/base';
import Tooltip, { TooltipPrimitive } from '@atlaskit/tooltip';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import styled from '@emotion/styled';
import { Permissions, Resources } from '@atlassian/cssxp-typescommon';

const uuidTooltipStyle = styled(TooltipPrimitive)`
  max-width: 500px;
  background: black;
  color: white;
  border-radius: 4px;
  padding: 4px 5px;
  font-size: 12px;
  box-sizing: content-box;
`;

export const UUIDSection = ({ entitlement }: { entitlement: EntitlementDetails }) => {
  if (isAccess(Permissions.SUBSCRIPTION_ENTITLEMENT_UUID_READ) && isResourceAccess(Resources.ENTITLEMENT_ALL)) {
    return (
      <SummarySectionV2.SummaryGridCalloutItem testId="summary-uuid">
        <div className="billing-plan">
          <label>UUID</label>
          <div className="entitlement-details-column" style={{ whiteSpace: 'nowrap' }}>
            <CopyableText>
              <Tooltip component={uuidTooltipStyle} content={entitlement.id} tag="span">
                <span className="entitlement-overflow-text">{entitlement.id}</span>
              </Tooltip>
            </CopyableText>
          </div>
        </div>
      </SummarySectionV2.SummaryGridCalloutItem>
    );
  }
  return null;
};
